var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeWidth":"2","d":"m3 3 18 18M3 21 21 3"}));
}

Close.defaultProps = {"aria-label":"Close","viewBox":"0 0 24 24","className":"StyledIcon-sc-ofa7kd-0 iJxtUR"};

module.exports = Close;

Close.default = Close;
